import script from "./form-dich-vu.vue?vue&type=script&setup=true&lang=js"
export * from "./form-dich-vu.vue?vue&type=script&setup=true&lang=js"

import "./form-dich-vu.vue?vue&type=style&index=0&id=8d1f0480&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d1f0480"]])

export default __exports__